module.exports = __webpack_public_path__ + "static/milkmoovement-logo-c1376ad3616b670ccee5145dc478a701.jpeg";